import React from "react";
import { Form, Select } from "antd";

const { Option } = Select;

export function SelectInput(props) {
  const [form] = Form.useForm();
  const getName = (value) => {
    if (props.nameKey) {
      return value[props.nameKey];
    }

    return value["name"];
  };

  return (
    <Form.Item
      name={props.name}
      label={props.label}
      initialValue={props.initialValue}
      rules={[
        {
          required: props.required,
          message: props.errorMessage,
        },
      ]}
      style={props.style}
      prefix={props.prefix}
    >
      <Select
        style={{ width: "100%" }}
        placement={props.placement}
        form={form}
        mode={props.mode}
        maxTagCount={props.maxTagCount}
        onChange={props.onChange}
        disabled={props.disabled}
        required={props.required}
        allowClear={props.allowClear}
        onSelect={props.onSelect}
        onDeselect={props.onDeselect}
        showSearch={props.showSearch}
        onSearch={props.onSearch}
        placeholder={props.placeholder}
        defaultValue={props.defaultValue}
        value={props.value}
        listHeight={props.listHeight}
        suffixIcon={props.suffixIcon}
        showArrow={props.showArrow}
        notFoundContent={props.notFoundContent}
        prefix={props.prefix}
      >
        {props.dataSource.map((value, key) => (
          <Option key={key} value={value[props.valueKey]}>
            {getName(value)}
          </Option>
        ))}
      </Select>
    </Form.Item>
  );
}
